import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

        return	<section className="service-details">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/human-like.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Human-like voice calls <br/> for follow-ups and <br/> lead nurturing.</h3>
                            <p>Our Voice AI agent interacts with customers using natural, conversational speech. It can make outbound calls (follow-ups, confirmations, surveys, promotions) and receive inbound calls, collecting information and converting leads just like a human representative.</p>

                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6">
                        <img src={publicUrl+"assets/images/resources/service-detail-22.jpg"} alt={ imagealt } className="wow fadeInRight" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>How It Supports Your Business</h3>
                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Lead qualification & nurturing
                                </li>
                                <li>Service reminders & appointment confirmations</li>
                                <li>Follow-up calls for conversions</li>
                                <li>Customer feedback & surveys</li>
                                <li>Promotional campaigns & offers</li>
                                <li>Order confirmations & support calls</li>
                            </ul>{/* /.list-unstyled service-details__list */}
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
                <div className="row">
                    <div className="col-lg-6 clearfix">
                        <img src={publicUrl+"assets/images/resources/smart-automation.jpg"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
                    </div>{/* /.col-lg-6 */}
                    <div className="col-lg-6">
                        <div className="service-details__content">
                            <h3>Smart Automation for Sales & Support</h3>
                            <p className="mb-3">Our AI voice agent helps streamline communication and improve customer experience by automating repetitive yet critical tasks.</p>

                            <ul className="list-unstyled service-details__list">
                                <li>
                                    Natural, conversational voice interaction
                                </li>
                                <li>Outbound & inbound call handling
                                </li>
                                <li>Real-time response and data collection
                                </li>
                                <li>Personalized conversation flows</li>
                                <li>CRM integration for lead tracking</li>
                            </ul>{/* /.list-unstyled service-details__list */}
                        </div>{/* /.service-details__content */}
                    </div>{/* /.col-lg-6 */}
                </div>{/* /.row */}
            </div>{/* /.container */}
        </section>

    }
}

export default ServiceDetails